/* ── HORLOGERIE THEME JS ── */

/* ── SCROLL ANIMATIONS ── */
const revealObs = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('on'); });
}, { threshold: 0.08 });
document.querySelectorAll('.reveal').forEach(el => revealObs.observe(el));

/* ── NAV SHADOW ── */
window.addEventListener('scroll', () => {
  document.querySelector('nav').style.boxShadow =
    window.scrollY > 10 ? '0 1px 20px rgba(0,0,0,0.06)' : 'none';
});

/* ── CART DRAWER ── */
const drawer      = document.getElementById('cart-drawer');
const overlay     = document.getElementById('cart-overlay');
const cartCountEl = document.getElementById('cart-count');
const cartItemsEl = document.getElementById('cart-items');
const cartEmptyEl = document.getElementById('cart-empty');
const cartFooterEl= document.getElementById('cart-footer');
const cartSubEl   = document.getElementById('cart-subtotal-price');

function openCart()  { drawer.classList.add('open'); overlay.classList.add('open'); document.body.style.overflow='hidden'; }
function closeCart() { drawer.classList.remove('open'); overlay.classList.remove('open'); document.body.style.overflow=''; }

document.getElementById('cart-trigger').addEventListener('click', openCart);
document.getElementById('cart-close').addEventListener('click', closeCart);
overlay.addEventListener('click', closeCart);

async function fetchCart() {
  try { return await (await fetch('/cart.js')).json(); } catch(e) { return null; }
}

function formatPrice(cents) {
  return 'QAR ' + (cents/100).toLocaleString('en-QA', {maximumFractionDigits:0});
}

function renderCart(cart) {
  if (!cart || cart.item_count === 0) {
    cartEmptyEl.style.display = 'block';
    cartFooterEl.style.display = 'none';
    cartCountEl.textContent = '0';
    cartItemsEl.innerHTML = '';
    cartItemsEl.appendChild(cartEmptyEl);
    return;
  }
  cartEmptyEl.style.display = 'none';
  cartFooterEl.style.display = 'flex';
  cartCountEl.textContent = cart.item_count;
  cartItemsEl.innerHTML = '';
  cart.items.forEach((item, idx) => {
    const el = document.createElement('div');
    el.className = 'cart-item';
    el.innerHTML = `
      <div class="cart-item-info">
        <div class="cart-item-name">${item.product_title}</div>
        <div class="cart-item-price">${formatPrice(item.price)}</div>
      </div>
      <div class="cart-item-actions">
        <div class="cart-item-qty">
          <button class="qty-btn" data-line="${idx+1}" data-action="dec">−</button>
          <span class="qty-num">${item.quantity}</span>
          <button class="qty-btn" data-line="${idx+1}" data-action="inc">+</button>
        </div>
        <button class="cart-item-remove" data-line="${idx+1}">Remove</button>
      </div>`;
    cartItemsEl.appendChild(el);
  });
  cartSubEl.textContent = formatPrice(cart.total_price);
  cartItemsEl.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const line = parseInt(btn.dataset.line);
      const action = btn.dataset.action;
      const qty = action === 'inc' ? cart.items[line-1].quantity+1 : Math.max(0,cart.items[line-1].quantity-1);
      await updateCartItem(line, qty);
    });
  });
  cartItemsEl.querySelectorAll('.cart-item-remove').forEach(btn => {
    btn.addEventListener('click', async () => { await updateCartItem(parseInt(btn.dataset.line), 0); });
  });
}

async function updateCartItem(line, quantity) {
  try {
    const res = await fetch('/cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({line, quantity})
    });
    renderCart(await res.json());
  } catch(e) { console.error(e); }
}

async function addToCart(variantId, name) {
  if (!variantId || variantId === 'VARIANT_ID') { showToast('Product not configured.'); return; }
  try {
    const res = await fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id: variantId, quantity: 1})
    });
    if (!res.ok) { const err=await res.json(); showToast(err.description||'Could not add.'); return; }
    const cart = await fetchCart();
    renderCart(cart);
    openCart();
    showToast(`${name} added.`);
  } catch(e) { showToast('Something went wrong.'); }
}

/* ── ADD TO CART BUTTONS (list rows) ── */
document.querySelectorAll('.atc-btn:not(.modal-atc)').forEach(btn => {
  btn.addEventListener('click', async (e) => {
    e.stopPropagation(); // don't trigger row click
    btn.textContent = 'Adding…'; btn.disabled = true;
    await addToCart(btn.dataset.variantId, btn.dataset.name);
    btn.textContent = 'Add to Cart'; btn.disabled = false;
  });
});

/* ── PRODUCT MODAL ── */
const modalOverlay = document.getElementById('modal-overlay');
const productModal = document.getElementById('product-modal');
const modalClose   = document.getElementById('modal-close');
const modalImg     = document.getElementById('modal-img');
const modalImgPh   = document.getElementById('modal-img-placeholder');
const modalType    = document.getElementById('modal-type');
const modalTitle   = document.getElementById('modal-title');
const modalDesc    = document.getElementById('modal-desc');
const modalPrice   = document.getElementById('modal-price');
const modalAtc     = document.getElementById('modal-atc');

function openModal(row) {
  const img     = row.dataset.img;
  const title   = row.dataset.title;
  const type    = row.dataset.type;
  const price   = row.dataset.price;
  const desc    = row.dataset.desc;
  const variant = row.dataset.variant;

  modalType.textContent  = type;
  modalTitle.textContent = title;
  modalDesc.textContent  = desc;
  modalPrice.textContent = price;
  modalAtc.dataset.variantId = variant;
  modalAtc.dataset.name      = title;

  if (img) {
    modalImg.src = img;
    modalImg.alt = title;
    modalImg.style.display = 'block';
    modalImgPh.style.display = 'none';
  } else {
    modalImg.style.display = 'none';
    modalImgPh.style.display = 'flex';
  }

  modalOverlay.classList.add('open');
  productModal.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeModal() {
  modalOverlay.classList.remove('open');
  productModal.classList.remove('open');
  document.body.style.overflow = '';
}

// Open modal on row click
document.querySelectorAll('.watch-row[data-modal="true"]').forEach(row => {
  row.addEventListener('click', (e) => {
    // Don't open if they clicked the ATC button
    if (e.target.closest('.atc-btn')) return;
    openModal(row);
  });
});

// Close modal
modalClose.addEventListener('click', closeModal);
modalOverlay.addEventListener('click', closeModal);
document.addEventListener('keydown', e => { if (e.key === 'Escape') closeModal(); });

// Modal Add to Cart
modalAtc.addEventListener('click', async () => {
  modalAtc.textContent = 'Adding…'; modalAtc.disabled = true;
  await addToCart(modalAtc.dataset.variantId, modalAtc.dataset.name);
  modalAtc.textContent = 'Add to Cart'; modalAtc.disabled = false;
  closeModal();
});

/* ── TOAST ── */
function showToast(msg) {
  const t = document.getElementById('toast');
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 3000);
}

/* ── INIT ── */
fetchCart().then(cart => { if (cart) renderCart(cart); });
